import { useNavigate } from 'react-router-dom';

import Button from 'core/buttons/Button';
import PageContent from 'layouts/PageContent';
import AccountForm from 'components/accounts/AccountForm';
import AccountProgressIndicatorModal from 'components/accounts/AccountProgressIndicatorModal';

import { buildRoute } from 'routes';

function AddAccount() {
  const navigate = useNavigate();

  return ( 
    <PageContent
      title="Add Account"
      rightTopEndContent={
        <Button onClick={() => navigate(buildRoute('accounts.index'))}>List Account</Button>
      }
    >
      <AccountForm isAddMode={true} />
      <AccountProgressIndicatorModal isAddMode={true} />
    </PageContent>
  );
}

export default AddAccount;